export default __webpack_public_path__ + "static/media/Group 214.706586f9.svg";